import { IS_SERVER } from 'src/utils/ssr';

if (!IS_SERVER) {
  /* eslint-disable prefer-destructuring, @typescript-eslint/naming-convention, no-undef */
  // @ts-ignore
  __webpack_nonce__ = window.__webpack_nonce__;
}

/** @knipignore */
// eslint-disable-next-line import/no-default-export
export default window.__webpack_nonce__;
